import React from 'react';
import { Col, Row, Skeleton } from 'antd';
import { I18n } from '@aws-amplify/core';

import { StatusFile } from '@/utils/enum';
import { useBeraJobSummaryResult } from '@/context/BeraJobSummaryResult';
import { useReportV2Result } from '@/components/views/BeraJob/BeraReportV2/_components/ReportResult/_hooks/useReportV2Result';
import { ResultBody, VideoFrame } from '@/components/views/BeraJob/BeraReportV2/_components/ReportResult';

import type { BeraClipFile, BeraReportV2 } from '@/types/Bera';
import type { StrainIndexReport } from '@/types/StrainIndex';

interface ContentProps {
	report: BeraReportV2;
	clip?: BeraClipFile | null;
	thumbnailUrl?: string | null;
	strainIndex?: StrainIndexReport;
}

export function Content({ report, clip, thumbnailUrl, strainIndex }: Readonly<ContentProps>): JSX.Element {
	const { file, jobSummary } = useBeraJobSummaryResult();

	const { result, isLoading, isError } = useReportV2Result({ report, file, jobSummary });

	const clipUrl = clip?.url;

	const isClipShown = clip?.status === StatusFile.PROCESSED && !!clipUrl;

	if (isLoading) {
		return <Skeleton active />;
	}

	if (isError || !result) {
		return <span>{I18n.get('Oops... Something went wrong!')}</span>;
	}

	return (
		<Row gutter={[0, 40]}>
			{isClipShown && (
				<Col span={24}>
					<VideoFrame key={thumbnailUrl ?? clipUrl} src={clipUrl} poster={thumbnailUrl ?? undefined} />
				</Col>
			)}
			<ResultBody steps={result.steps} strainIndex={strainIndex} />
		</Row>
	);
}
